module.exports = __webpack_public_path__ + "static/media/00.4559cbf3.jpg";